import React from 'react';

import {WBSlateElementType} from '../../../components/Slate/WBSlate/types';
import {WBSlateReduxBridgeDisabled} from '../../../components/Slate/WBSlateReduxBridge';
import {ReportContext} from '../../../state/reports/context';
import {useEntityPageContext} from '../context';
import {TEAM_README_CONTEXT_VALUE} from './context';

type TeamReadmeReadyProps = {
  readOnly: boolean;
  value: WBSlateElementType[];
  onChange: (newValue: WBSlateElementType[]) => void;
};

export const TeamReadmeReady: React.FC<TeamReadmeReadyProps> = ({
  readOnly,
  value,
  onChange,
}) => {
  const {profileViewID, entityName} = useEntityPageContext();
  return (
    <ReportContext.Provider value={TEAM_README_CONTEXT_VALUE}>
      <WBSlateReduxBridgeDisabled
        readOnly={readOnly}
        entityName={entityName}
        projectName={``}
        viewId={profileViewID}
        value={value}
        onChange={onChange}
      />
    </ReportContext.Provider>
  );
};
